import PropTypes from "prop-types"
import React from "react"
import compose from "ramda/src/compose"
import { translate } from "react-i18next"

import Header from "./Header"
import CompletedRequests from "./CompletedRequests"
import ProgressRequests from "./ProgressRequests"

import { withHalfHeightOverflow } from "hocs/withHalfHeightOverflow"

import styles from "./styles.css"

const Requests = ({
  t,
  progressDemands,
  completedDemands,
  getDescription,
  onShowDetailsProgress,
  onTrackTechnician,
  onShowProblemSolvedModal,
  loading,
  onShowDetailsCompleted,
  onDownload,
  onSendMail,
  onAudioRequestModal
}) => {
  return (
    <table className={styles.table}>
      <caption className={styles.srOnly}></caption>
      <Header t={t} />
      <tbody>
        <ProgressRequests
          t={t}
          progressDemands={progressDemands}
          getDescription={getDescription}
          onShowDetailsProgress={onShowDetailsProgress}
          onTrackTechnician={onTrackTechnician}
          onShowProblemSolvedModal={onShowProblemSolvedModal}
          loading={loading}
        />
        <CompletedRequests
          t={t}
          completedDemands={completedDemands}
          getDescription={getDescription}
          onShowDetailsCompleted={onShowDetailsCompleted}
          onDownload={onDownload}
          onSendMail={onSendMail}
          loading={loading}
          onAudioRequestModal={onAudioRequestModal}
        />
      </tbody>
    </table>
  )
}

Requests.propTypes = {
  t: PropTypes.func,
  progressDemands: PropTypes.array,
  completedDemands: PropTypes.array,
  getDescription: PropTypes.func,
  onShowDetailsCompleted: PropTypes.func,
  onShowDetailsProgress: PropTypes.func,
  onTrackTechnician: PropTypes.func,
  onShowProblemSolvedModal: PropTypes.func,
  loading: PropTypes.bool,
  downloadRequestDetails: PropTypes.func.isRequired,
  sendMailRequestDetails: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired,
  onSendMail: PropTypes.func.isRequired,
  onAudioRequestModal: PropTypes.func
}

export default compose(translate(), withHalfHeightOverflow)(Requests)



// WEBPACK FOOTER //
// ./src/scenes/IncidentManager/components/Requests/index.js